import { render, staticRenderFns } from "./PsoriasisReportPhase.vue?vue&type=template&id=4e184eaa&scoped=true&"
import script from "./PsoriasisReportPhase.vue?vue&type=script&lang=js&"
export * from "./PsoriasisReportPhase.vue?vue&type=script&lang=js&"
import style0 from "./PsoriasisReportPhase.vue?vue&type=style&index=0&id=4e184eaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e184eaa",
  null
  
)

export default component.exports